// extracted by mini-css-extract-plugin
module.exports = {"container_s":"styles_container_s__3zD92","main":"styles_main__S3qhu","main_profile":"styles_main_profile__iPrHI"};